import React, { FC } from "react";
import { AppBar, Box } from "@mui/material";

import "../Configuration/configuration.css";
import "./networkSettings.css";
import CurrentNetworkStatus from "./CurrentNetworkStatus";
import StaticIpConfiguration from "./StaticIpConfiguration";
import WifiHotspotConfiguration from "./WifiHotspotConfiguration";
import WifiConfiguration from "./WifiConfiguration";
import SystemStatus from "./SystemStatus";
import { BASE_API_URL } from "../../utils/apiUtils";
import { useLocation, useNavigate } from "react-router-dom";

const NetworkSettings: FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const isWifiRoute = location.pathname.startsWith("/wifi");

	const handleLogoClick = () => {
		navigate("/");
	};

	return (
		<>
			{isWifiRoute ? (
				<AppBar sx={{ backgroundColor: "#FEFEFE" }} position="sticky" elevation={0}>
					<Box className="appbar-content-wrapper" sx={{ marginLeft: 0 }}>
						{process.env.REACT_APP_HIDE_GG_LOGO !== "true" ? (
							<Box sx={{ width: "280px", padding: "0.5rem", cursor: "pointer" }} onClick={handleLogoClick}>
								<img src={`${BASE_API_URL}/media/icons/logo.png`} alt={"Logo"} width="100%" />
							</Box>
						) : null}
					</Box>
				</AppBar>
			) : null}

			<Box className={`network-settings-component-wrapper ${isWifiRoute ? "wifi-route" : ""}`}>
				<CurrentNetworkStatus />
				<StaticIpConfiguration />
				<WifiHotspotConfiguration />
				<WifiConfiguration />
				<SystemStatus />
			</Box>
		</>
	);
};

export default NetworkSettings;
